export default "__VITE_ASSET__CWpRSk1b__"